/**
 * @generated SignedSource<<741cb72699edec38b3b5efa4e68b85a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedBottomModule_bottomModule$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModuleContent_bottomModule" | "SharedBottomModuleSpacer_bottomModule">;
  readonly " $fragmentType": "SharedBottomModule_bottomModule";
}>;
export type SharedBottomModule_bottomModule$key = ReadonlyArray<{
  readonly " $data"?: SharedBottomModule_bottomModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModule_bottomModule">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedBottomModule_bottomModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedBottomModuleContent_bottomModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedBottomModuleSpacer_bottomModule"
    }
  ],
  "type": "BottomModule",
  "abstractKey": null
};

(node as any).hash = "5f832e10816e078dbc61f5d81a29bf8d";

export default node;
